<template>
  <div :class="buttonFont">
    <button v-on:click="pressed" :class="classes" :style="style" type=button :disabled="disabled">
      <slot> </slot>
    </button>
  </div>
</template>

<script>
export default {
  name: 'portal-shared-library-button-button',
  components: {
  },
  props: {
    disabled: { type: Boolean, default: false },
    go: { type: Boolean, default: false },
    usePressed: { type: Boolean, default: false },
    type: { type: String, default: "normal" },
    padding: { type: String, default: "2px" },
  },
  data() {
    return {
    };
  },
  computed: {
    buttonFont() {
      if (this.go) {
        return "rc-input-font-white";
      }
      if (this.type === "largeAction") {
        return "rc-input-font-white";
      }
      if (this.type === "mediumAction") {
        return "rc-input-font-white";
      }
      if (this.type === "smallAction") {
        return "rc-input-font-white";
      }
      if (this.type === 'smallComplete') {
        return "rc-input-font-white";
      }
      return "rc-input-font-black"
    },
    classes() {
      if (this.go) {
        if (this.type == "secondaryAction") {
          return "rc-input-button-normal-go2-v3 rc-input-width rc-text-medium";
        }
        return "rc-input-button-normal-go-v3 rc-input-width rc-text-medium";
      }
      if (this.type === "largeAction") {
        return "rc-input-button-normal-go-v3 rc-input-width rc-text-large";
      }
      if (this.type === "mediumAction") {
        return "rc-input-button-normal-go-v3 rc-input-width rc-text-medium";
      }
      if (this.type === "smallAction") {
        return "rc-input-button-normal-go-v3 rc-input-width rc-text-small";
      }
      if (this.type === 'smallComplete') {
        return "rc-input-button-complete-v2 rc-input-width rc-text-small";
      }
      return "rc-input-button-normalv2 rc-input-width rc-text-small";
    },
    style() {
      return "height: 30px; padding: " + this.padding;
    }
  },
  methods: {
    pressed: function () {
      if (this.usePressed) {
        this.$emit('pressed');
        return;
      } else {
        this.$emit('click');
      }
    },
  },
}
</script>
